import {message as antMessage} from "antd";

export const message = antMessage;
export default message;
